import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import AddressView, {NewAddress} from "./AddressView";
import 'react-table/react-table.css';
import ReactTable from 'react-table';
import {isNullEmptyOrWhitespace, SpaceString} from "../../constants";

class AddressesView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      addresses: props.addresses ? props.addresses : [],
      selectedAddress: null,
    };

    this.handleSaveAddress = this.handleSaveAddress.bind(this);
    this.handleNewAddress = this.handleNewAddress.bind(this);
    this.handleSelectAddress = this.handleSelectAddress.bind(this);
    this.handleAddressDelete = this.handleAddressDelete.bind(this);
    this.getCurrentState = this.getCurrentState.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(JSON.stringify(prevProps.addresses) !== JSON.stringify(this.props.addresses)){
      this.setState({addresses: this.props.addresses});
    }
  }  
  
  handleSaveAddress(selectedAddress) {
    let added = false;
    let addresses = [...this.state.addresses].map(x => {
      let returnVal = x;
      if (returnVal.id == selectedAddress.id) {
        added = true;
        return selectedAddress;
      }
      return returnVal;
    });
    if(!added){
      addresses = [...this.state.addresses, selectedAddress];
    }

    this.setState({addresses, selectedAddress: null}, () => {
      if(this.props.onChange){
        this.props.onChange(addresses);
      }
    });
  }

  handleNewAddress() {
    let count = this.state.addresses.reduce((a, b) => {
      return b.id < 0 ? a + 1 : a;
    }, 0);
    this.setState({selectedAddress: NewAddress(count)});
  }

  handleAddressDelete(c){
    let addresses = this.state.addresses.filter(x => x.id != c.id);
    if(this.props.onChange){
      this.props.onChange(addresses);
    }
    this.setState({ addresses });
  }

  handleSelectAddress(ev, address) {
    ev.preventDefault();
    this.setState({selectedAddress: address});
  }

  getCurrentState(){
    if(this.state.selectedAddress){
      toastr.error(`Please finish entering all address information`);
      return null;
    }
    return this.state.addresses;
  }
  
  getColumns() {
    return [
      {
        accessor: 'addressType',
        Header: 'Type',
        maxWidth: 100,
      }, {
        id: 'address',
        Header: 'Address',
        accessor: x => (<a href="#"
                           onClick={(e) => this.handleSelectAddress(e, x)}>{ isNullEmptyOrWhitespace(x.line1) ? 'Enter address' : SpaceString([x.line1, x.line2], ', ')}</a>),
        width: 175,
      },
      {
        accessor: 'suburbName',
        Header: 'Suburb',
      },
      {
        accessor: 'postCode',
        Header: 'Post Code',
        maxWidth: 95,
      },
      {
        accessor: 'state',
        Header: 'State',
        maxWidth: 75,
      },
      {
        id: 'isPrimary',
        Header: 'Primary',
        accessor: x => (<i className={`fa ${x.isPrimary ? 'fa-check' : 'fa-times'}`}/>),
        maxWidth: 75,
      },
      {
        id: 'updated',
        Header: 'Updated',
        accessor: c => c.id > 0 ? moment(c.updatedDate ? c.updatedDate : c.createdDate).format("DD/MM/YYYY h:mm:ss a") : '',
      },
      {
        accessor: 'updatedBy',
        Header: 'Updated By',
      },
      {
        id: 'delete',
        Header: '',
        accessor: c => (this.props.enableDelete && <Button color="danger" onClick={() => this.handleAddressDelete(c)}><i className="fa fa-times" /></Button>),
        maxWidth: 60,
      }
    ];
  }

  render() {
    let {addresses, selectedAddress} = this.state;

    return (
        <div style={{marginBottom: '20px'}}>
          <div className="form-group row" style={{marginLeft: '0px'}}>
            <h6>
              Addresses&nbsp;{this.props.enableAdd &&
            <Button color="success" onClick={this.handleNewAddress}><i className="fa fa-plus"/>&nbsp;&nbsp;Add
              address</Button>}
            </h6>
          </div>
          {this.state.selectedAddress ?
              (<AddressView
                  address={this.state.selectedAddress}
                  onComplete={(x) => this.handleSaveAddress(x)}
                  enableAddressType={this.props.enableAddressType}
                  enableIsPrimary={this.props.enableIsPrimary}
                  onCancel={() => this.setState({selectedAddress: null})}
              />)
              :
              (<div className="row">
                <div className={'col-12'}>
                  <ReactTable
                      sortable={false}
                      filterable={false}
                      showPagination={false}
                      data={addresses}
                      columns={this.getColumns()}
                      minRows={2}
                  />
                </div>
              </div>)}
        </div>
    );
  }
}

AddressesView.propTypes = {
  addresses: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  enableAdd: PropTypes.bool,
  enableDelete: PropTypes.bool,
  enableIsPrimary: PropTypes.bool,
  enableAddressType: PropTypes.bool,
};

AddressesView.defatultProps = {
  addresses: [],
  enableAdd: true,
  enableDelete: true,
  enableIsPrimary: true,
  enableAddressType: true,
};

export default AddressesView;